import produce from 'immer';
import { Types as FilterTypes } from './actions';

export const INITIAL_STATE = {
  filters: {
    clubs: { data: [], loading: false },
    competitions: { data: [], loading: false },
    seasons: { data: [], loading: false },
    dates: { data: ['2020-02-07'], loading: false },
    stadiums: { data: [], loading: false },
    carouselDates: {
      data: {
        gameweeks: [],
        dates: [],
      },
      loading: false,
    },
  },
};

export default function filters(state = INITIAL_STATE, action) {
  const { type, payload } = action;

  return produce(state, draft => {
    switch (type) {
      case FilterTypes.GET_CLUBS_REQUEST: {
        draft.filters.clubs.loading = true;
        break;
      }
      case FilterTypes.GET_CLUBS_SUCCESS: {
        draft.filters.clubs.data = payload.filters;
        draft.filters.clubs.loading = false;
        break;
      }
      case FilterTypes.GET_CLUBS_FAILURE: {
        draft.filters.clubs.loading = false;
        break;
      }

      case FilterTypes.GET_COMPETITIONS_REQUEST: {
        draft.filters.competitions.loading = true;
        break;
      }
      case FilterTypes.GET_COMPETITIONS_SUCCESS: {
        draft.filters.competitions.data = payload.filters;
        draft.filters.competitions.loading = false;
        break;
      }
      case FilterTypes.GET_COMPETITIONS_FAILURE: {
        draft.filters.competitions.loading = false;
        break;
      }

      case FilterTypes.GET_SEASONS_REQUEST: {
        draft.filters.seasons.loading = true;
        break;
      }
      case FilterTypes.GET_SEASONS_SUCCESS: {
        draft.filters.seasons.data = payload.filters;
        draft.filters.seasons.loading = false;
        break;
      }
      case FilterTypes.GET_SEASONS_FAILURE: {
        draft.filters.seasons.loading = false;
        break;
      }

      case FilterTypes.GET_DATES_REQUEST: {
        draft.filters.dates.loading = true;
        break;
      }
      case FilterTypes.GET_DATES_SUCCESS: {
        draft.filters.dates.data = payload.filters;
        draft.filters.dates.loading = false;
        break;
      }
      case FilterTypes.GET_DATES_FAILURE: {
        draft.filters.dates.loading = false;
        break;
      }

      case FilterTypes.GET_STADIUMS_REQUEST: {
        draft.filters.stadiums.loading = true;
        break;
      }
      case FilterTypes.GET_STADIUMS_SUCCESS: {
        draft.filters.stadiums.data = payload.filters;
        draft.filters.stadiums.loading = false;
        break;
      }
      case FilterTypes.GET_STADIUMS_FAILURE: {
        draft.filters.stadiums.loading = false;
        break;
      }

      case FilterTypes.GET_CAROUSEL_DATES_REQUEST: {
        draft.filters.carouselDates.loading = true;
        break;
      }
      case FilterTypes.GET_CAROUSEL_DATES_SUCCESS: {
        draft.filters.carouselDates.data = payload.filters;
        draft.filters.carouselDates.loading = false;
        break;
      }
      case FilterTypes.GET_CAROUSEL_DATES_FAILURE: {
        draft.filters.carouselDates.loading = false;
        break;
      }
      default:
    }
  });
}

// For copy & paste
// case FilterTypes._REQUEST: {
//   draft.filters..loading = true;
//   break;
// }
// case FilterTypes._SUCCESS: {
//   draft.filters..data = payload.filters;
//   draft.loading = false;
//   break;
// }
// case FilterTypes._FAILURE: {
//   draft.filters..loading = true;
//   break;
// }
